<template>
  <v-tooltip v-model="show" content-class="custom-tooltip" bottom>
    <template v-slot:activator="{ on }">
      <div
        v-on="on"
        :style="{
          position: 'fixed',
          left: `${tooltipPosition.x}px`,
          top: `${tooltipPosition.y}px`,
          width: '0px',
          height: '0px',
          pointerEvents: 'none',
        }"
      ></div>
    </template>
    <div v-if="hoveredMark">
      <ul
        style="margin: 0; padding-left: 1.2em; padding-right: 1.2em;text-align: left;"
      >
        <li v-if="hoveredMark.description" class="text-description">
          {{ hoveredMark.description }}
        </li>
        <li v-if="hoveredMark.woundType">{{ hoveredMark.woundType }}</li>
        <li v-if="dimensionsFilled">
          {{
            hoveredMark.dimensions?.length?.value
              ? `P:${hoveredMark.dimensions?.length?.value} ${hoveredMark.dimensions?.length?.unit}`
              : ''
          }}
          {{
            hoveredMark.dimensions?.width?.value
              ? `L:${hoveredMark.dimensions?.width?.value} ${hoveredMark.dimensions?.width?.unit}`
              : ''
          }}
          {{
            hoveredMark.dimensions?.depth?.value
              ? `D:${hoveredMark.dimensions?.depth?.value} ${hoveredMark.dimensions?.depth?.unit}`
              : ''
          }}
        </li>
      </ul>
    </div>
  </v-tooltip>
</template>

<script>
export default {
  name: 'TooltipMarkSingle',
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    hoveredMark: {
      type: Object,
      default: null,
    },
    tooltipPosition: {
      type: Object,
      default: null,
    },
  },
  computed: {
    dimensionsFilled() {
      const { length, width, depth } = this.hoveredMark.dimensions;

      if (length.value > 0 || width.value > 0 || depth.value > 0) {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>
<style lang="css" scoped>
.custom-tooltip {
  max-width: 20vw;
  min-width: 5vw;
  white-space: normal;
}

.text-description {
  word-wrap: break-word;
  max-width: 19.5vw;
}
</style>
